
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.24 25.39l8.47-8.47a.5.5 0 0 0 0-.71L26.3 14.8a.5.5 0 0 0-.71 0L18 22.38l-3.58-3.58a.5.5 0 0 0-.71 0l-1.41 1.41a.5.5 0 0 0 0 .71l4.47 4.47a1.73 1.73 0 0 0 1.23.51 1.76 1.76 0 0 0 1.24-.51M20 5a15 15 0 1 0 15 15A15 15 0 0 0 20 5m0 33a18 18 0 1 1 18-18 18 18 0 0 1-18 18"}})])
          )
        }
      }
    